import React from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Stack,
  Typography,
  useTheme
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import CopyToClipboard from "@/ui-component/CustomUiComponent/ClipBoard";

interface Props {
  setTicketResponseSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  setCreatedTicketUrl: React.Dispatch<React.SetStateAction<string>>;
  createdTicketUrl: string;
}
/**
 * Component to display a success message upon successful ticket creation in GitLab.
 */

const TicketCreatedSuccessComponent: React.FC<Props> = ({
  setTicketResponseSuccess,
  setCreatedTicketUrl,
  createdTicketUrl
}: Props) => {
  const theme = useTheme();
  return (
    <Card
      elevation={3}
      sx={{
        borderRadius: 2,
        width: "100%",
        height: "100%"
      }}
    >
      <CardHeader
        action={
          <IconButton
            color="primary"
            onClick={() => {
              setTicketResponseSuccess(false);
              setCreatedTicketUrl("");
            }}
          >
            <CloseIcon />
          </IconButton>
        }
      />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        }}
      >
        <CardContent>
          <Stack spacing={3} alignItems="center" justifyContent="center">
            <CheckCircleOutlineIcon
              sx={{
                fontSize: 50,
                color: theme.palette.primary.light
              }}
            />
            <Typography variant="h5" fontWeight={600} textAlign="center">
              Ticket Created Successfully!
            </Typography>
            <Typography variant="body1" textAlign="center">
              Your ticket has been successfully created in GitLab.
            </Typography>

            <CopyToClipboard shortUrl={createdTicketUrl} />

            <Button
              variant="outlined"
              color="primary"
              onClick={() => {
                setTicketResponseSuccess(false);
                setCreatedTicketUrl("");
              }}
            >
              Create Another Ticket
            </Button>
          </Stack>
        </CardContent>
      </Box>
    </Card>
  );
};

export default TicketCreatedSuccessComponent;
